import { dataTable as actions } from '../actions'
import * as selectors from '../selectors/dataTable'

export const initialState = {
  sortBy: {},
  isSortAscending: {},
  page: {},
  perPage: {}
}

const setSortBy = (id, value) => dispatch =>
  dispatch({
    type: actions.SET_SORT_BY,
    payload: { id, value }
  })

const toggleIsSortAscending = id => dispatch =>
  dispatch({
    type: actions.TOGGLE_SORT_ASC,
    payload: id
  })

const resetIsSortAscending = id => dispatch =>
  dispatch({
    type: actions.RESET_SORT_ASC,
    payload: id
  })

export const setSort = (id, sortBy) => (dispatch, getState) => {
  const currentSortBy = selectors.sortBySelector(getState(), { id })

  if (sortBy === currentSortBy) {
    dispatch(toggleIsSortAscending(id))
  } else {
    dispatch(setSortBy(id, sortBy))
    dispatch(resetIsSortAscending(id))
  }
}
